import router from '@/router'
import store from '@/store'
import { login } from '@/services/auth/login'
import { changePasswordFirstLogin } from '@/services/auth/changePasswordFirstLogin'
import { checkOTPCode } from '@/services/auth/checkOTPCode'
import { me } from '@/services/auth/me'
import { recoveryPassword } from '@/services/auth/recoveryPassword'
import { getMisModulos } from '@/services/auth/getMisModulos'
import { getPermisos } from '@/services/auth/getPermisos'
import { logout } from '@/services/auth/logout'

// import _ from 'lodash'

const state = () => ({
  user: null,
  username: null,
  role: null,
  locale: 'es', // getLocale(),
  auth: {
    loggedIn: false,
    accessToken: null,
    refreshToken: null,
    temporalToken: null
  },
  modules: [],
  permisos: [],
})

const getters = {
  httpQueryHeaders: state => {
    const headers = {
      'Content-type': 'application/json',
      'access-control-allow-origin': '*'
    }
    /*
    if (state.currentCompany !== '') {
      headers['X-Fidery-Company'] = state.currentCompany
    }
    if (state.currentBusiness !== '') {
      headers['X-Fidery-Business'] = state.currentBusiness
    }
    */
    return headers
  },
  user: state => state.user,
  modules: state => state.modules,
  permisos: state => state.permisos,
  hasPermissionEditVisiblity: state => {
    return state.permisos?.PermitirEdicionPermisos
  },
  hasOcultarInformacionEmpresasCertificados: state => {
    return state.permisos?.OcultarInformacionEmpresasCertificados
  },
  hasModuleVacacionesAEAT: state => {
    return state.modules.some(x => x.idModulo === 1)
  },
  hasModuleAgrupacionEmails: state => {
    return state.modules.some(x => x.idModulo === 2)
  },
  hasModuleEnvioSMS: state => {
    return state.modules.some(x => x.idModulo === 3)
  },
  hasModuleNotificacionesTerceros: state => {
    return state.modules.some(x => x.idModulo === 4)
  },
  hasModuleControlDuplicados: state => {
    return state.modules.some(x => x.idModulo === 5)
  },

  hasModuleGruposReparto: state => {
    return state.modules.some(x => x.idModulo === 6)
  },
  
  hasModuleCalendariosFestivosDescarga: state => {
    return state.modules.some(x => x.idModulo === 7)
  },
  hasModuleHorariosDescarga: state => {
    return state.modules.some(x => x.idModulo === 8)
  },

  hasModuleIntegracionAAD: state => {
    return state.modules.some(x => x.idModulo === 9)
  },

  hasModuleExclusionOrganismos: state => {
    return state.modules.some(x => x.idModulo === 10)
  },

  hasModuleAsignacionMetadatosAEAT: state => {
    return state.modules.some(x => x.idModulo === 11)
  },
  hasModuleAsignacionSedeOrganismoCIF: state => {
    return state.modules.some(x => x.idModulo === 12)
  },
  hasModuleAsignacionContenido: state => {
    return state.modules.some(x => x.idModulo === 13)
  },
  hasModuleAsignacionAsunto: state => {
    return state.modules.some(x => x.idModulo === 14)
  },

  
  hasModuleAgrupaciones: state => {
    return state.modules.some(x => x.idModulo === 15)
  },

  
  hasModuleCustomSMTPZerocoma: state => {
    return state.modules.some(x => x.idModulo === 16)
  },
  hasModuleCustomSMTPCliente: state => {
    return state.modules.some(x => x.idModulo === 17)
  },
  hasModuleCustomMails: state => {
    return state.modules.some(x => x.idModulo === 18)
  },
  hasModuleCustomLogo: state => {
    return state.modules.some(x => x.idModulo === 19)
  },

  hasModuleRenombradoFicherosZIP: state => {
    return state.modules.some(x => x.idModulo === 20)
  },

  // Garrigues
  hasModuleDescargaAdjuntosPrincipales: state => {
    return state.modules.some(x => x.idModulo === 21)
  },
  
  hasModuleCustomColors: state => {
    return state.modules.some(x => x.idModulo === 22)
  },

  hasModuleImportaciones: state => {
    return state.modules.some(x => x.idModulo === 23)
  },
  hasAnyImportaciones: state => {
    return state.modules.some(x => x.idModulo === 23) &&
      (state.permisos?.TieneImportaciones)
  },

  hasModuleCustomDownloadZIP: state => {
    return state.modules.some(x => x.idModulo === 24)
  },

  hasModuleAsignacionEmailReglas: state => {
    return state.modules.some(x => x.idModulo === 25)
  },

  hasModulePermisosGruposTraspasoNEOs: state => {
    return state.modules.some(x => x.idModulo === 26)
  },

  hasModuleFlujoEstadosAvisos: state => {
    return state.modules.some(x => x.idModulo === 27)
  },
  hasModuleFlujoAceptacion: state => {
    return state.modules.some(x => x.idModulo === 28)
  },

  hasModuleDobleFactor: state => {
    return state.modules.some(x => x.idModulo === 29)
  },

  hasModuleSAML2: state => {
    return state.modules.some(x => x.idModulo === 30)
  },

  hasModuleColumnasDinamicas: state => {
    return state.modules.some(x => x.idModulo === 31)
  },

  hasModulePresentacionesAEAT: state => {
    return state.modules.some(x => x.idModulo === 32)
  },

  hasModuleContestacionDiligencias: state => {
    return state.modules.some(x => x.idModulo === 37)
  },
  hasModuleAsistenciaIA: state => {
    return state.modules.some(x => x.idModulo === 38)
  },

  // Lizentia
  hasModuleOrgProvinces: state => {
    return state.modules.some(x => x.idModulo === 33)
  },
  hasModuleAPIRequests: state => {
    return state.modules.some(x => x.idModulo === 34)
  },
  
  hasModuleHotFolder: state => {
    return state.modules.some(x => x.idModulo === 35)
  },
  

  idTipoProvisionamientoDistribuidor: state => state.user?.idTipoProvisionamiento,
  userId: state => state.user?.me?.id,
  idCliente: state => state.user?.idEmpresa,
  loggedIn: state => !!((state.auth.loggedIn && state.auth.accessToken)),
  accessToken: state => state.auth.accessToken,
  refreshToken: state => state.auth.refreshToken,
  temporalToken: state => state.auth.temporalToken,
  userName: state => state.username,
  role: state => (state.role || state.user?.Rol),
  idTipoServicioCliente: state => (state.user?.idTipoServicioCliente),
  locale: state => state.user?.me?.lang_code ? state.user.me.lang_code : state.locale,
  lang: (state, getters) => (langs = []) => {
    let lang = getters.locale
    if (!langs.includes(lang)) {
      lang = lang.split('-').shift()
      /*
      if (!langs.includes(lang)) {
        lang = i18n.fallbackLocale
      }
      */
    }

    return lang
  },
}

const mutations = {
  setUsername (state, username) {
    state.username = username
  },
  setRole (state, role) {
    state.role = role
  },
  setUser (state, user) {
    state.user = user
    state.auth.loggedIn = true
  },
  setModules (state, modules) {
    state.modules = modules
  },
  setUserData (state, userData) {
    if (state.user?.me) {
      state.user.me = userData
    }
  },
  removeUser (state) {
    state.user = null
    state.modules = []
    state.permisos = []
    state.auth.loggedIn = false
    state.locale = 'es' // getLocale()
    // i18n.locale = getLocale()
  },
  setTokens (state, { accessToken, refreshToken, temporalToken }) {
    state.auth.accessToken = accessToken
    state.auth.refreshToken = refreshToken
    state.auth.temporalToken = temporalToken
  },
  removeTokens (state) {
    state.auth.accessToken = null
    state.auth.refreshToken = null
    state.auth.temporalToken = null
  },
  get_modules_success (state, modules) {
    state.modules = modules
  },
  get_permisos_success (state, permisos) {
    state.permisos = permisos
  },
}

async function commonLogin (commit, data) {
  commit('setTokens', {
    accessToken: data.Token,
    refreshToken: data.RefreshToken,
    temporalToken: data.TemporalToken,
  })
  if (data.TemporalToken) {
    // Creamos error y gestiona Login
    const errorPwdCad = { 
      blnError: true,
      msgError: '',
      codError: 'COD' + data.StepCode,
      stepCode: data.StepCode,
    }
    if (data.StepCode === 1) {
      // Contraseña expirada (necesario cambio contraseña)
      errorPwdCad.msgError = 'Contraseña caducada. Use la recuperación de contraseña para generar una nueva'
    }
    throw errorPwdCad
  } else {
    // Login sin pasos previos (AuthWeb)
    const user = await me()
    if (user.blnError === true) {
      throw user
    } else {
      commit('setUser', user.respuesta)
      // TASK POST LOGIN
      store.commit('app/setFormChanges', false)
      store.commit('setIsLoading', false)
      store.dispatch('app/updateidClienteFilterNav', null)
      store.dispatch('app/updateidClienteFilterAlerts', null)
      if (user.respuesta.Rol === 'SuperAdministrador') {
        // Reset Dashboard filter
        if (store.getters['dashboard/getUnableDashboard']) {
          store.dispatch('dashboard/setSelectedClient', -1)
        }
      }
      await store.dispatch('app/getColors') 
      await store.dispatch('auth/getPermisos') 
      store.dispatch('app/updateFrontColors')
    }
    router.push({ name: process.env.VUE_APP_REDIRECT_LOGGED_IN })
  }
}

const actions = {
  async loginTokens ({ commit }, { Token, RefreshToken }) {
    await commonLogin(commit, {
      Token,
      RefreshToken,
    })
  },
  async login ({ commit }, { email, password }) {
    // commit('setUsername', email)
    const data = await login(email, password)
    if (data.blnError === true) {
      throw data
    } else {
      await commonLogin(commit, data)
    }
  },
  async firstLoginPassword ({ commit }, { oldPassword, password }) {
    const data = await changePasswordFirstLogin(password, oldPassword)
    if (data.blnError === true) {
      throw data
    } else {
      await commonLogin(commit, data)
    }
  },
  async checkOTPLogin ({ commit }, { otpCode }) {
    const data = await checkOTPCode(otpCode)
    if (data.blnError === true) {
      throw data
    } else {
      await commonLogin(commit, data)
    }
  },
  async logout ({ commit }) {
    try {
      await logout()
    } catch (error) {
      console.error(error)
    }
    commit('removeUser')
    commit('removeTokens')
    store.dispatch('app/updatecontrolFlagLicense', false)
    store.dispatch('app/updatecontrolFlagWizard', false)

    // Reset all stores
    store.dispatch('notifications/resetStateWithoutSort')
    store.dispatch('historicalUser/resetStateWithoutSort')
    store.dispatch('historicalGroup/resetStateWithoutSort')
    store.dispatch('historicalRule/resetStateWithoutSort')
    store.dispatch('historicalConfigflow/resetStateWithoutSort')
    store.dispatch('historicalProceding/resetStateWithoutSort')
    store.dispatch('historicalOrgprovinces/resetStateWithoutSort')
    store.dispatch('historicalAPIrequests/resetStateWithoutSort')
    store.dispatch('historicalClient/resetStateWithoutSort')
    store.dispatch('historicalCert/resetStateWithoutSort')
    store.dispatch('historicalCompany/resetStateWithoutSort')
    store.dispatch('historicalNEO/resetStateWithoutSort')
    store.dispatch('companies/resetStateWithoutSort')
    
    store.dispatch('locations/resetStateWithoutSort')
    store.dispatch('companylocations/resetStateWithoutSort') 
    store.dispatch('companyothercertificates/resetStateWithoutSort') 
    store.dispatch('clientlocations/resetStateWithoutSort')
    
    store.dispatch('certificates/resetStateWithoutSort')
    store.dispatch('certcompanies/resetStateWithoutSort')
    store.dispatch('clients/resetStateWithoutSort')
    store.dispatch('users/resetStateWithoutSort')
    store.dispatch('userscompanies/resetStateWithoutSort')
    store.dispatch('userstatus/resetStateWithoutSort')

    store.dispatch('groups/resetStateWithoutSort')
    store.dispatch('groupusers/resetStateWithoutSort')
    store.dispatch('groupcompanies/resetStateWithoutSort')
    store.dispatch('groupstatus/resetStateWithoutSort')
    store.dispatch('groupgroups/resetStateWithoutSort')
    store.dispatch('neogroups/resetStateWithoutSort')
    store.dispatch('neopresentations/resetStateWithoutSort')
    store.dispatch('usergroups/resetStateWithoutSort')

    store.dispatch('groupingcompanies/resetStateWithoutSort')
    store.dispatch('groupinglocations/resetStateWithoutSort')
    store.dispatch('groupingagencies/resetStateWithoutSort')

    store.dispatch('rules/resetStateWithoutSort')
    store.dispatch('rulegroups/resetStateWithoutSort')

    store.dispatch('configflow/resetStateWithoutSort')
    store.dispatch('orgprovinces/resetStateWithoutSort')
    store.dispatch('apirequests/resetStateWithoutSort')
    store.dispatch('procedings/resetStateWithoutSort')

    store.dispatch('documentmaster/resetStateWithoutSort')

    store.dispatch('imports/resetStateWithoutSort')

    // Distribuidor
    store.dispatch('distributors/resetStateWithoutSort')
    store.dispatch('distributorlocations/resetStateWithoutSort')
    store.dispatch('historicalDistributor/resetStateWithoutSort')

    // Papelera
    store.dispatch('trashUsers/resetStateWithoutSort')
    store.dispatch('trashHistoricalUsers/resetStateWithoutSort')
    store.dispatch('trashNotifications/resetStateWithoutSort')
    store.dispatch('trashHistoricalNotifications/resetStateWithoutSort')
    store.dispatch('trashCertificates/resetStateWithoutSort')
    store.dispatch('trashHistoricalCertificates/resetStateWithoutSort')
    store.dispatch('trashCompanies/resetStateWithoutSort')
    store.dispatch('trashHistoricalCompanies/resetStateWithoutSort')
    store.dispatch('trashGroups/resetStateWithoutSort')
    store.dispatch('trashHistoricalGroups/resetStateWithoutSort')

    // Actualmente sin uso
    store.dispatch('trashClients/resetStateWithoutSort')
    store.dispatch('trashHistoricalClients/resetStateWithoutSort')

    // Reset Dashboard filter
    store.dispatch('dashboard/setSelectedClient', -1)
    store.dispatch('dashboard/setSelectedClientName', null)

    // Reset filter general
    store.dispatch('app/updateidClienteFilterNav', null)
    store.dispatch('app/updateidClienteFilterAlerts', null)

    // Reset colors
    store.dispatch('app/resetColors')

    // Reset Chatbot
    store.commit('app/setshowButtonChatbot', false)

    router.push({ name: process.env.VUE_APP_REDIRECT_FAILED_AUTHENTICATION })
  },
  getModules ({ commit }) {
    return new Promise((resolve, reject) => {
      getMisModulos().then(response => {
        if (response.blnError) {
          return Promise.reject(response)
        }
        commit('get_modules_success', response.Modulos)
        resolve(response)
      })
        .catch(err => {
          reject(err)
        })
    })
  },
  getPermisos ({ commit }) {
    return new Promise((resolve, reject) => {
      getPermisos().then(response => {
        if (response.blnError) {
          return Promise.reject(response)
        }
        commit('get_permisos_success', response.respuesta)
        resolve(response)
      })
        .catch(err => {
          reject(err)
        })
    })
  },
  async recoveryPassword ({ commit }, { email }) {
    const data = await recoveryPassword(email)
    if (data.blnError === true) {
      throw data
    } else {
      commit('setTokens', {
        accessToken: data.Token,
        refreshToken: data.RefreshToken
      })
      commit('setUser', null)
      router.push({ name: process.env.VUE_APP_REDIRECT_LOGGED_IN })
    }
  },
  async me ({ commit }, { navigate = false }) {
    const data = await me()
    if (data.blnError === true) {
      throw data
    } else {
      commit('setUser', data.respuesta)
      if (navigate) {
        const IdUsuario = data.respuesta.IdUsuario
        router.push({ name: 'configurations/users/profile', params: { id: IdUsuario } })
      }
    }
  },
  async updateUser ({ commit, state }, data) {
    commit('setUserData', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
